import { useEffect, useState } from "react";
import { Row, Col, Pagination, Form, FormControl } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import "./userShopItem.css";

import ShopAdds from "../shopAds/ShopAdds";
import UserbuyShopViewModel from "../../components/ShopViewModel/UserbuyShopViewModel";
import OrderSumary from "../../pages/PaymentModal/Components/OrderSumary";
import ShopCategory from "../Category";
import Addtocartmodal from "../Addtocartmodal";
import ShareOption from "../Shareoption";
import ShareModel from "../Sharemodel";

import { useShopItemsData } from "../../hooks/useShopItemsData";
import { useShopPagination } from "../../hooks/useShopPagination";
import { useUserItemShopState } from "../../hooks/useUserItemShopState";

import ShopItemCard from "./components/ShopItemCard";
import ShopDummyCard from "./components/ShopDummyCard";
import ShopSkeletonCard from "./components/ShopSkeletonCard";
import { SadIcon } from "../../assets";

const UserItemShop = ({
  shopid,
  itemData,
  shopdata,
  regular,
  back,
  salespromotion,
  specialoffer,
  newItemdata,
  isDynamic,
  shopData,
}) => {
  const location = useLocation();

  // When parent already loaded items (isDynamic), skip duplicate fetch
  const hasProvidedItems = Boolean(isDynamic);
  const resolvedShopId =
    typeof shopid === "string" || typeof shopid === "number"
      ? shopid
      : shopid?._id || shopData?._id || shopdata?._id;

  const {
    data,
    newsearchdata,
    filterregular,
    filtersales,
    filterspecial,
    vehiclesearchdata,
    isLoading,
  } = useShopItemsData(resolvedShopId, undefined, {
    skipItems: hasProvidedItems,
  });

  // Prefer parent props when isDynamic; fall back to hook data
  const displayRegular = (regular?.length ? regular : filterregular) || [];
  const displaySpecial =
    (specialoffer?.length ? specialoffer : filterspecial) || [];
  const displaySales =
    (salespromotion?.length ? salespromotion : filtersales) || [];
  const displayAll =
    (newItemdata?.length
      ? newItemdata
      : [...displayRegular, ...displaySpecial, ...displaySales]) || [];

  // Pagination Hook
  const { currentPages, handlePageChange } = useShopPagination();

  // Consolidated Local UI State Hook
  const {
    showshare,
    showmodal,
    shareurl,
    show,
    shopview,
    showcategory,
    showModal,
    isOpenone,
    activeTab,
    showDropdown,
    setShowmodal,
    setShareurl,
    setShow,
    setShowcategory,
    SetisOpenone,
    setActiveTab,
    handleClosetwo,
    handleClosemodal,
    handleShowModal,
    handleCloseshare,
    handleShowshare,
    handleFocus,
    handleBlur,
    UserShopView,
  } = useUserItemShopState();

  // Search Query State
  const [searchQuery, setSearchQuery] = useState("");

  const renderItems = (dataToRender, tabKey, isProperty = false) => {
    if (isLoading) {
      return (
        <div className="row ps-2 pe-2 user-shop-items-grid">
          {Array.from({ length: 12 }).map((_, idx) => (
            <ShopSkeletonCard key={`skeleton-${tabKey}-${idx}`} />
          ))}
        </div>
      );
    }

    const safeData = Array.isArray(dataToRender) ? dataToRender : [];

    // Apply Search Filter
    const filteredData = safeData.filter((item) => {
      if (!searchQuery) return true;
      const itemName =
        item?.itemname || item?.companyname || item?.shopname || "";
      return itemName.toLowerCase().includes(searchQuery.toLowerCase());
    });

    if (filteredData.length === 0) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center w-100 text-center"
          style={{ minHeight: "200px" }}
        >
          <SadIcon />
          <h4 className="text-muted mb-1">No Data Found</h4>
          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            Nothing is available to display right now.
          </p>
        </div>
      );
    }

    const itemsPerPage = isDynamic ? 12 : 50;
    const currentPage = currentPages[tabKey] || 1;

    const effectiveData = isDynamic
      ? filteredData.map((item) => ({ type: "real", data: item }))
      : filteredData.length < 100
        ? [
            ...filteredData.map((item) => ({ type: "real", data: item })),
            ...Array(100 - filteredData.length).fill({ type: "dummy" }),
          ]
        : filteredData.map((item) => ({ type: "real", data: item }));

    const firstIndex = (currentPage - 1) * itemsPerPage;
    const lastIndex = firstIndex + itemsPerPage;
    const currentDisplay = effectiveData.slice(firstIndex, lastIndex);
    const totalPages = Math.ceil(effectiveData.length / itemsPerPage);

    const itemsJsx = currentDisplay.map((item, idx) => {
      if (item.type === "dummy") {
        return (
          <ShopDummyCard
            key={`dummy-${tabKey}-${currentPage}-${idx}`}
            isProperty={isProperty}
          />
        );
      } else {
        return (
          <ShopItemCard
            key={item.data?._id || idx}
            item={item}
            isProperty={isProperty}
            shopid={shopid}
            setShowmodal={setShowmodal}
            setShareurl={setShareurl}
            setShow={setShow}
            UserShopView={UserShopView}
            shopData={shopData || shopdata}
          />
        );
      }
    });

    let paginationJsx = null;
    if (totalPages > 1) {
      let items = [];

      if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={currentPage === i}
              onClick={() => handlePageChange(tabKey, i)}
            >
              {i}
            </Pagination.Item>,
          );
        }
      } else {
        if (currentPage <= 4) {
          for (let i = 1; i <= 5; i++) {
            items.push(
              <Pagination.Item
                key={i}
                active={currentPage === i}
                onClick={() => handlePageChange(tabKey, i)}
              >
                {i}
              </Pagination.Item>,
            );
          }
          items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
          items.push(
            <Pagination.Item
              key={totalPages}
              onClick={() => handlePageChange(tabKey, totalPages)}
            >
              {totalPages}
            </Pagination.Item>,
          );
        } else if (currentPage > totalPages - 4) {
          items.push(
            <Pagination.Item
              key={1}
              onClick={() => handlePageChange(tabKey, 1)}
            >
              1
            </Pagination.Item>,
          );
          items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
          for (let i = totalPages - 4; i <= totalPages; i++) {
            items.push(
              <Pagination.Item
                key={i}
                active={currentPage === i}
                onClick={() => handlePageChange(tabKey, i)}
              >
                {i}
              </Pagination.Item>,
            );
          }
        } else {
          items.push(
            <Pagination.Item
              key={1}
              onClick={() => handlePageChange(tabKey, 1)}
            >
              1
            </Pagination.Item>,
          );
          items.push(<Pagination.Ellipsis key="ellipsis1" disabled />);
          for (let i = currentPage - 1; i <= currentPage + 1; i++) {
            items.push(
              <Pagination.Item
                key={i}
                active={currentPage === i}
                onClick={() => handlePageChange(tabKey, i)}
              >
                {i}
              </Pagination.Item>,
            );
          }
          items.push(<Pagination.Ellipsis key="ellipsis2" disabled />);
          items.push(
            <Pagination.Item
              key={totalPages}
              onClick={() => handlePageChange(tabKey, totalPages)}
            >
              {totalPages}
            </Pagination.Item>,
          );
        }
      }

      paginationJsx = (
        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(tabKey, currentPage - 1)}
              disabled={currentPage === 1}
            />
            {items}
            <Pagination.Next
              onClick={() => handlePageChange(tabKey, currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      );
    }

    return (
      <>
        <div className="row ps-2 pe-2 user-shop-items-grid">{itemsJsx}</div>
        {paginationJsx}
      </>
    );
  };

  useEffect(() => {
    if (location?.pathname === `/Byvehicleuserprofile/${resolvedShopId}`) {
      setActiveTab("jobs");
    } else if (displayAll.length > 0) {
      if (displayRegular.length > 0) setActiveTab("jobs");
      else if (displaySales.length > 0) setActiveTab("sales");
      else if (displaySpecial.length > 0) setActiveTab("special");
      else setActiveTab("jobs");
    } else {
      setActiveTab("home");
    }
  }, [
    displayAll.length,
    displayRegular.length,
    displaySales.length,
    displaySpecial.length,
    location?.pathname,
    resolvedShopId,
    setActiveTab,
  ]);

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shareurl={shareurl}
      />
      <Addtocartmodal showModal={showModal} SetisOpenone={SetisOpenone} />
      {isOpenone === true && (
        <OrderSumary SetisOpenone={SetisOpenone} isOpenone={isOpenone} />
      )}
      {location.pathname === "/buy-single-property" ? "" : <ShopAdds />}

      <div
        className="user-shop-items-layout border-top pt-2 me-lg-4 ms-lg-4 me-md-1 ms-md-1"
        onBlur={() => setShowcategory(false)}
      >
        <UserbuyShopViewModel
          show={show}
          handleClosetwo={handleClosetwo}
          handleShowModal={handleShowModal}
          shopview={shopview}
        />
        <Row>
          <Col className="position-relative">
            {location.pathname === "/buy-single-property" ||
            location.pathname === "/single-item-buy" ? null : (
              <div className="user-shop-item-search">
                <Form
                  className="position-relative ps-0"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                >
                  <FormControl
                    type="text"
                    placeholder="Search"
                    className="mr-sm-2 search-buing-area"
                    name="itemname"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Form>
              </div>
            )}
            <Tabs
              id="shop-tabs"
              className="mb-1 user-shop-item-tabs"
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              {/* HOME / DEFAULT TAB */}
              {displayAll.length === 0 ? (
                <Tab eventKey="home" title="Shop Items" className="jobviewhead">
                  <div className="noscroll shop-scroll">
                    {location.pathname === "/single-item-buy" ||
                    location.pathname === "/buy-single-property"
                      ? renderItems(shopdata || [], "home", true)
                      : renderItems(
                          vehiclesearchdata?.length > 0
                            ? vehiclesearchdata
                            : newsearchdata?.length > 0
                              ? newsearchdata
                              : itemData?.itemdata || data || [],
                          "home",
                          false,
                        )}
                  </div>
                </Tab>
              ) : null}

              {/* REGULAR ITEMS TAB */}
              {displayAll.length > 0 && (
                <Tab
                  eventKey="jobs"
                  title="Regular items"
                  className="jobviewhead"
                >
                  {showcategory === 1 && <ShopCategory />}
                  <div className="shop-scroll noscroll">
                    <div className="items_scroll noscroll">
                      {renderItems(displayRegular, "jobs", false)}
                    </div>
                  </div>
                </Tab>
              )}

              {/* SALES TAB */}
              {displayAll.length > 0 &&
                location?.pathname !==
                  `/Byvehicleuserprofile/${resolvedShopId}` && (
                  <Tab eventKey="sales" title="Sales Promotion">
                    {renderItems(displaySales, "sales", false)}
                  </Tab>
                )}

              {/* SPECIAL TAB */}
              {displayAll.length > 0 &&
                location?.pathname !==
                  `/Byvehicleuserprofile/${resolvedShopId}` && (
                  <Tab eventKey="special" title="Special Offers">
                    {renderItems(displaySpecial, "special", false)}
                  </Tab>
                )}
            </Tabs>

          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserItemShop;
